import React, { useEffect, useState, useContext, useCallback } from "react";
import { useForm, FormProvider, useWatch } from "react-hook-form";
import { useHistory } from "react-router-dom";
//Material

//Component
import { Modal } from "../../stories/modal";
import { ReactTable } from "../../stories/react-table";
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
//Function
import { GetListViewHistory } from "./api";
import { getViewHistoryColumns } from "./columns/view-history";
import { GetUser } from "./../../utils/sessions";
import { url, method } from "./signalr";
import { useSignalR } from "./../function-api/useSignalR";
import  ViewUpload  from "./view-upload";
import { GetViewUpload } from "./api";

function ViewHistory() {
  //State
  const [DataList, setDataList] = useState([]);
  const history = useHistory();
  const [detail, setDetail] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [keepSearch, setKeepSearch] = useState(false);
  const fetch = async () => {
    let param = { "USER_ID": GetUser(),"MODE":"Refresh" };
    let res = await GetListViewHistory(param);
    setDataList(res);
  }
  //Effect
  useEffect(() => {
    // const fetch = async () => {
    //   let param = { "USER_ID": GetUser() };
    //   let res = await GetListViewHistory(param);
    //   setDataList(res);
    // }
    fetch();
    localStorage.setItem("SearchTable","");
  }, []);

  const signalRHandler =  useCallback(async (data) => {
    //console.log(data);
    fetch();
    //setDataList(data)
    setKeepSearch(true);
  }, []);
  
  useSignalR(url, method, signalRHandler);

  const onOpenAddModal = () =>{
    history.push("/UploadCSV");
  }

  const onCloseViewModal = () => {
    setOpenModal(false);
  };

  const onViewModal = (LOAD_ID) =>{
    const fetch = async () => { 
      let param = {"LOAD_ID" : LOAD_ID};
      let res = await GetViewUpload(param);
      setDetail(res);
    }
    fetch();
    setOpenModal(true);
  }

  return (
    <div>
      <BaseContainer maxWidth={false}>
        <BoxTemplate1 height="80vh" title="Text Loader" 
        //</BaseContainer>add onClickAdd={onOpenAddModal}
        >
          <FormProvider>
            <ReactTable
              keyField="ID"
              data={DataList}
              columns={getViewHistoryColumns(onViewModal)}
              addButton={true}
              handleOnAdd={(e) => onOpenAddModal()}
              keepStateSearch={keepSearch}
            />
          </FormProvider>
        </BoxTemplate1>
        <ViewUpload
          open={openModal}
          onClose={onCloseViewModal}
          Detail={detail}
        />
      </BaseContainer>
    </div>
  );
}
export default ViewHistory;
